import React from "react";
import { Button } from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const ImportButton = ({handleImportClick, isSaving, label, ...props}) => (
    <Button
        color="primary" 
        size="small"
        variant="outlined"
        endIcon={<FileDownloadIcon />}
        onClick={() => handleImportClick()}
        {...props}
    >
        {label || "Редактировать"}
    </Button>
)

export default ImportButton;